import * as React from 'react'
import Popup from 'reactjs-popup'
import ItemPicker from '../resources_records/ItemPicker'
import { loadPickingListItemOptions } from '../../api/items'
import usePickingListLineFormController from '../../hooks/usePickingListLineFormController'
import type { PickingListLineItemOption, PickingListLineValues } from '../../hooks/usePickingListLineFormController'
import ErrorMessage from '../job_plannings/list_app/ErrorMessage'

type AddPickingListLineButtonProps = {
  jobId: string
  currentUser: { username: string }
  initialItem?: PickingListLineItemOption
  buttonTitle?: string
  windowTitle?: string
  buttonClass?: string
}

type PickingListLineFormFieldsProps = {
  currentUser: { username: string }
  values: PickingListLineValues
  setValues: React.Dispatch<React.SetStateAction<PickingListLineValues>>
}

function PickingListLineFormFields({ currentUser, values, setValues }: PickingListLineFormFieldsProps) {
  const inputName = field => `picking_list_line[${field}]`
  const inputId = field => `picking-list-line-form-${field}`

  return (
    <>
      <div className="row">
        <div className="col-sm-12 form-group">
          <label htmlFor={inputId('item')}>Vare</label>
          <ItemPicker
            item={values.item || {}}
            setItem={val => setValues({ ...values, item: val || {} })}
            id={inputId('item')}
            name={inputName('item_id')}
            customLoadOptions={loadPickingListItemOptions}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12 form-group">
          <label htmlFor={inputId('user')}>Bruger</label>
          <input
            id={inputId('user')}
            type="text"
            className="form-control col-xs-12"
            name={inputName('user')}
            value={currentUser.username}
            disabled
            readOnly
          />
        </div>
        <div className="col-sm-12 form-group">
          <label htmlFor={inputId('date')}>Dato</label>
          <input
            id={inputId('date')}
            required
            type="date"
            className="form-control col-xs-12"
            name={inputName('date')}
            value={values.date}
            onChange={e => setValues({ ...values, date: e.target.value })}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12 form-group">
          <label htmlFor={inputId('quantity')}>Antal</label>
          <input
            id={inputId('quantity')}
            required
            type="number"
            step={0.1}
            className="form-control col-xs-12"
            name={inputName('quantity')}
            value={values.quantity}
            onChange={e => setValues({ ...values, quantity: e.target.value })}
          />
        </div>
      </div>
    </>
  )
}

export default function AddPickingListLineButton({
  jobId,
  currentUser,
  initialItem,
  buttonTitle = 'Tilføj',
  windowTitle = 'Tilføj',
  buttonClass = 'btn btn-outline-primary mr-2',
}: AddPickingListLineButtonProps) {
  const { values, setValues, submit, reset, isLoading, isError, error, isSubmitDisabled } = usePickingListLineFormController(jobId, initialItem)

  return (
    <Popup
      trigger={
        <button type="button" className={buttonClass}>
          {buttonTitle}
        </button>
      }
      position="center center"
      contentStyle={{ width: '100%', maxWidth: '420px', maxHeight: '100%', overflowX: 'hidden', overflowY: 'auto', zIndex: 2000 }}
      overlayStyle={{ zIndex: 1999 }}
      onClose={reset}
      modal
      nested
    >
      {close => (
        <div className="resources-record-modal modal-popup">
          <a className="close" onClick={close}>
            &times;
          </a>
          <div className="resources-record-modal-header popup-header">{windowTitle}</div>
          <form>
            <div className="resources-record-modal-content popup-content">
              <ErrorMessage isError={isError} error={error} />
              <PickingListLineFormFields currentUser={currentUser} values={values} setValues={setValues} />
            </div>
            <div className="resources-record-modal-actions popup-actions">
              <button type="button" className="btn btn-outline-secondary" onClick={close}>
                Luk
              </button>
              <button type="button" className="btn btn-primary" onClick={() => submit(close)} disabled={isSubmitDisabled || isLoading}>
                {isLoading ? <i className="fa fa-spinner fa-spin" /> : 'Save'}
              </button>
            </div>
          </form>
        </div>
      )}
    </Popup>
  )
}
